window.addEventListener("load", () => {
  // Función para obtener cookies
  function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined; // Devuelve undefined si la cookie no existe
  }

  // Atributos a partir de cookies requeridas
  const cookiesToCheck = ["_fbc", "_fbp"];

  // Construir el objeto note_attributes excluyendo cookies inválidas
  const noteAttributes = Object.fromEntries(
    cookiesToCheck.map((cookieName) => [cookieName, getCookie(cookieName)])
      .filter(([_, value]) => value !== undefined) // Excluir cookies no definidas
  );

  // Verificar si hay atributos válidos
  if (Object.keys(noteAttributes).length === 0) {
    return; // No hacer nada si no hay cookies válidas
  }

  // Realizar la solicitud para actualizar los note_attributes
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ attributes: noteAttributes }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error al actualizar los note_attributes: ${response.statusText}`);
      }
      return response.json();
    })
    .then(() => {
      console.log("note_attributes actualizados correctamente.");
    })
    .catch((error) => {
      console.error("Error al intentar actualizar los note_attributes del carrito:", error);
    });
});